import styled, {css} from 'styled-components';
import Utility from '../../../util/utilityfunctions';

const override = css`
	border: var(--px-1) solid var(--border-color) !important;
	background-color: var(--bg-color) !important;
	color: var(--text-color) !important;
`;

const lightDisabled = css`
	--border-color: ${({theme}) => theme.color['grey250']};
	--bg-color: ${({theme}) => theme.color['grey250']};
	--text-color: ${({theme}) => theme.color['grey400']};
`;

const darkDisabled = css`
	--border-color: ${({theme}) => theme.color['grey200']};
	--bg-color: ${({theme}) => theme.color['grey200']};
	--text-color: ${({theme}) => theme.color['grey300']};
`;

const lightMode = css`
`;

const darkMode = css`
`;

export default styled.div`
	${Utility.isDarkTheme() ? darkMode : lightMode};

	--size: var(--px-40);
	--icon-size: var(--px-16);
	--padding: var(--px-11);

	&.fb-label {
		--padding: var(--px-11) var(--px-36);
		--width: auto;
	}

	&.fb-icon {
		--width: var(--size);
	}

	.motif-button,
	.motif-button:disabled {
		height: var(--size);
		width: var(--width);
		.motif-icon {
			svg {
				width: var(--icon-size) !important;
				height: var(--icon-size) !important;
			}
		}
	}
`;
